export const PENDING_REGISTRATION_SEAM = {
  entry: 'registration intake',
  reviewSurface: 'directory pending registrations',
  approvalAction: 'manager approve/reject decision',
  downstreamEffects: [
    'employee record creation',
    'directory visibility',
    'onboarding eligibility',
    'driver account readiness',
  ],
};
